const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 114",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Bold-M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.393,113.184l45.117,-0c8.447,-0 13.623,-4.639 14.013,-13.184l3.174,-69.043l4.492,0c3.272,0 5.664,-2.344 5.664,-5.566c0,-3.174 -2.392,-5.469 -5.664,-5.469l-20.556,-0l-0,-7.031c-0,-8.301 -5.176,-12.891 -14.405,-12.891l-18.603,0c-9.277,0 -14.404,4.59 -14.404,12.891l-0,7.031l-20.557,-0c-3.223,-0 -5.664,2.295 -5.664,5.469c-0,3.271 2.441,5.566 5.664,5.566l4.492,0l3.174,69.092c0.391,8.496 5.566,13.135 14.063,13.135Zm10.4,-99.952c-0,-2.001 1.367,-3.271 3.662,-3.271l16.895,-0c2.294,-0 3.71,1.27 3.71,3.271l0,6.69l-24.267,-0l-0,-6.69Zm-8.838,88.672c-2.539,0 -4.15,-1.757 -4.297,-4.638l-3.076,-66.309l56.641,0l-3.028,66.309c-0.097,2.929 -1.709,4.638 -4.297,4.638l-41.943,0Zm6.738,-6.933c2.491,-0 4.053,-1.612 3.955,-3.955l-1.464,-49.024c-0.049,-2.343 -1.661,-3.857 -4.053,-3.857c-2.393,-0 -3.955,1.562 -3.858,3.906l1.465,49.072c0.098,2.295 1.66,3.858 3.955,3.858Zm14.258,-0c2.344,-0 3.955,-1.514 3.955,-3.858l0,-49.121c0,-2.343 -1.611,-3.857 -3.955,-3.857c-2.392,-0 -4.004,1.514 -4.004,3.857l0,49.121c0,2.344 1.612,3.858 4.004,3.858Zm14.258,-0c2.295,-0 3.857,-1.563 3.955,-3.858l1.465,-49.072c0.049,-2.344 -1.465,-3.906 -3.906,-3.906c-2.344,-0 -4.004,1.562 -4.053,3.857l-1.465,49.072c-0.049,2.295 1.514,3.907 4.004,3.907Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.432b77dfa136ae7382052c86bea5cf67.svg";
export { ForwardRef as ReactComponent };